import { render } from "./GlobalSearchHeader.vue?vue&type=template&id=9a1781fc"
import script from "./GlobalSearchHeader.vue?vue&type=script&lang=js"
export * from "./GlobalSearchHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__